// extracted by mini-css-extract-plugin
module.exports = {"main":"_3WOVwZ","container":"_8MhLeX","mobile":"_3_eHlL","title":"_3seGBF","text":"lobDGl","link":"_3OLcx3"};